import {
    CylindersIcon,
    DisplacementIcon,
    LengthIcon,
    LessIcon,
    MoreIcon,
    PowerIcon,
    PowerToWeightIcon,
    QuarterMileIcon,
    RarityIcon,
    SpeedIcon,
    StopwatchIcon,
    TorqueIcon,
    WeightIcon,
} from '../icons/SpecIcons';

/**
 * Which glyph stands for which figure.
 *
 * A lookup and nothing else, in `ui/` because it binds a domain key to a
 * DRAWING — the same shape `BottomNavigation`'s `ICONS` takes, and for the same
 * reason: the day a twelfth subject is added it is a row in `DUEL_SPECS` and a
 * row here, and no component has to be opened.
 *
 * `duelSubjectIcon` answers null for a subject with no glyph rather than
 * throwing, and the question strip draws the word alone for it. That is a worse
 * question and it is not a broken screen — and it is the state the app is in for
 * exactly as long as it takes somebody to draw the missing pictogram.
 */
const SUBJECT_ICONS = {
    topSpeed: SpeedIcon,
    power: PowerIcon,
    cylinders: CylindersIcon,
    length: LengthIcon,
    weight: WeightIcon,
    zeroToHundred: StopwatchIcon,
    displacement: DisplacementIcon,
    torque: TorqueIcon,
    powerToWeight: PowerToWeightIcon,
    quarterMile: QuarterMileIcon,
    production: RarityIcon,
};

export function duelSubjectIcon(specKey) {
    return SUBJECT_ICONS[specKey] ?? null;
}

/** The arrow the middle chip wears. Up is more of something; down is less. */
export function duelDirectionIcon(wins) {
    return wins === 'lower' ? LessIcon : MoreIcon;
}

export { SUBJECT_ICONS };
